<script setup lang="ts">
import type { APIFormatKey } from '@autobid/ui/constants/SEARCH_API_FORMAT_TYPES'
import type { SearchFormSelectProps } from '@autobid/ui/types/components/Select'
import type { LocationQueryValue } from 'vue-router'
import Select from '@autobid/ui/components/elements/select/Select.vue'
import { useCustomSelect } from '@autobid/ui/composables/useCustomSelect'
import { useDictionary } from '@autobid/ui/composables/useDictionary'
import { useDictionarySelect } from '@autobid/ui/composables/useDictionarySelect'
import { SEARCH_API_FORMAT_TYPES } from '@autobid/ui/constants/SEARCH_API_FORMAT_TYPES'
import { checkIsDefaultSelectName } from '@autobid/ui/utils/formkit/checkIsDefaultSelectName'

const props = defineProps<SearchFormSelectProps>()
const { dictionary, suspense } = useDictionary({ type: 'full' })
onServerPrefetch(suspense)

const item = computed(() => props.context.dictionary ? dictionary.value?.[props.context.dictionary] : undefined)

const multiple = computed(() => {
  if (!item.value) {
    return props.context.multiple
  }
  const isDefaultName = checkIsDefaultSelectName(
    props.context.node?.name?.split('-')[0] ?? '',
  )
  const getType = () => {
    if (isDefaultName) {
      return SEARCH_API_FORMAT_TYPES[props.context.dictionary as APIFormatKey]
    }
    return (
      SEARCH_API_FORMAT_TYPES[props.context.dictionary as APIFormatKey]
      ?? SEARCH_API_FORMAT_TYPES[
        props.context.node?.name?.split('-')[0] as APIFormatKey
      ]
    )
  }
  const type = getType()
  return type?.includes('[')
})

const { options, value } = item.value
  ? useDictionarySelect({
      context: props.context,
      item: item.value,
    })
  : useCustomSelect(props.context)
</script>

<template>
  <Select
    :value="multiple && value && !Array.isArray(value) ? [value] : value"
    :multiple="multiple"
    :placeholder="context.placeholder"
    :options="options"
    :input-id="context.id"
    :disable-search="context.disableSearch"
    @change="(e) => (value = e as unknown as LocationQueryValue)"
  />
</template>
